import React, { useEffect } from "react";
import CountUp from "react-countup";
import { Box, BoxInner } from "../styles";
import ImagIcon from "./ImageIcon";
import { helpers } from "../../../utils";

function Block(props) {
  const { value, display, duration, suffix, prefix } = props;

  return (
    <Box>
      <div style={{ paddingTop: "10px" }}>
        <ImagIcon display={display} />
      </div>
      <p style={{ textAlign: "center", paddingTop: "20px", fontSize: "16px" }}>
        {display}
      </p>
      <div
        style={{
          justifyContent: "center",
          display: "flex",
          alignItems: "center",
        }}
      >
        <CountUp
          className="ovv-countup-span"
          suffix={suffix}
          prefix={prefix}
          end={value}
          separator=","
          duration={duration ?? 3}
          // redraw
        />
      </div>
    </Box>
  );
}

export default Block;
